import { useEffect, useState } from 'react'

export function useLiveStatus(intervalMs = 15000): boolean {
  const [live, setLive] = useState(false)
  useEffect(() => {
    let active = true
    const controller = new AbortController()
    const check = async () => {
      try {
        const response = await fetch('/api/v1/live/status', { cache: 'no-store', signal: controller.signal })
        if (!response.ok) throw new Error('status unavailable')
        const data: { live?: boolean } = await response.json()
        if (active) setLive(data.live === true)
      } catch {
        if (active) setLive(false)
      }
    }
    void check()
    const timer = window.setInterval(() => { void check() }, intervalMs)
    return () => { active = false; controller.abort(); window.clearInterval(timer) }
  }, [intervalMs])
  return live
}
